import React from 'react'

const ArrowDropDown = ({ width = "24", height = "24", fill = "#000000" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10l5 5 5-5H7z" fill={fill}/>
  </svg>
)

export default ArrowDropDown
